import isyBoxLogo from "~/assets/images/sizing-tools/isy-box/isy-box-logo.png";

export const sizingToolData = [
  {
    title: "Systèmes de fixation",
    description:
      "Calculez facilement votre système avec les outils de dimensionnement des marques.",
    tools: [
      {
        brandSlug: "avasco-solar",
        url: "https://solarspeed.avasco.be/#/projects",
      },
      {
        brandSlug: "esdec-enstall",
        url: "https://enstallidprdb2c.b2clogin.com/enstallidprdb2c.onmicrosoft.com/b2c_1a_seamlessmigration_signuporsignin/oauth2/v2.0/authorize?client_id=1bafd7ed-fb6b-44bf-983a-c4447e50766e&scope=https%3A%2F%2FenstallidPRDB2C.onmicrosoft.com%2F68928c1f-aa86-4d34-be4f-b8d22a9b551b%2FData.Read%20openid%20profile%20offline_access&redirect_uri=https%3A%2F%2Fmy.enstall.com%2F&client-request-id=019bb6f9-bf35-7bf0-973c-c2f9ac8abf11&response_mode=fragment&response_type=code&x-client-SKU=msal.js.browser&x-client-VER=3.30.0&client_info=1&code_challenge=ovFiRsNLrRgaxrxCaO7luEUVfPz9FmcIHgOlFd43KPg&code_challenge_method=S256&nonce=019bb6f9-bf37-786f-aa59-fdb996d62a58&state=eyJpZCI6IjAxOWJiNmY5LWJmMzYtNzZmMC04ODJmLTU2ZTdhZTc2ZDU0MCIsIm1ldGEiOnsiaW50ZXJhY3Rpb25UeXBlIjoicmVkaXJlY3QifX0%3D",
      },
      {
        brandSlug: "isy-pv",
        url: "https://www.isy-pv.com/configurateur-isy-pv/",
      },
      {
        title: "ISY-BOX",
        image: isyBoxLogo,
        url: "https://www.isy-pv.com/calculateur/",
      },
      {
        brandSlug: "k2-systems",
        url: "https://base.k2-systems.com/#/summary",
      },
    ],
  },
  {
    title: "Onduleurs",
    description:
      "Calculez en ligne le matériel de fixation dont vous aurez besoin pour les panneaux que vous allez installer. Grâce à ces outils de dimensionnement des marques, vous vous assurez de commander les bons matériaux et les bonnes quantités.",
    tools: [
      {
        brandSlug: "enphase",
        url: "https://enphase.com/fr-fr/installers/microinverters/calculator",
      },
      {
        brandSlug: "sungrow",
        url: "https://design.isolarcloud.com",
      },
      {
        brandSlug: "huawei",
        url: "https://eu5.smartdesign.huawei.com/sdwebportal/app.html#/login",
      },
      {
        brandSlug: "solis",
        url: "https://design.soliscloud.com/login",
      },
      {
        brandSlug: "sofar",
        url: "https://www.opensolar.com",
      },
      {
        brandSlug: "sma",
        url: "https://www.sunnydesignweb.com/sdweb/#/Home",
      },
      {
        brandSlug: "solaredge",
        url: "https://login.solaredge.com/login?response_type=code&client_id=6v6t0lmjrmftqu71mbechdjbec&scope=email+openid&state=043dqEVm-BzkGv1mMsMeHVIl-oSVOExq5LuPbpSJsQA%3D&redirect_uri=https://designer.solaredge.com/login",
      },
      {
        brandSlug: "fronius",
        url: "https://creator.fronius.com/",
      },
    ],
  },
  {
    title: "Batteries",
    description:
      "Le configurateur du système de batterie Huawei vous aide à déterminer les composants nécessaires à une installation photovoltaïque Huawei associée à une batterie domestique.",
    tools: [
      {
        brandSlug: "huawei",
        url: "https://eu5.smartdesign.huawei.com/sdwebportal/app.html#/login",
      },
    ],
  },
];
